import { render, staticRenderFns } from "./StopCalls.vue?vue&type=template&id=b192d82a&"
import script from "./StopCalls.vue?vue&type=script&lang=js&"
export * from "./StopCalls.vue?vue&type=script&lang=js&"
import style0 from "./StopCalls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports